<template>
  <div class="content-box">
    <div class="content-body">
      <div class="page-title">问题反馈</div>
      <div class="table-div hover-bg" style="font-size: 16px; margin-top:40px">
        <div class="search-box">
          <el-form
              ref="searchForm"
              size="small"
              :inline="true"
              :model="search">
            <el-row class="input-box">
              <el-form-item label="问答状态：">
                <el-select v-model="search.status" placeholder="请选择问答状态" clearable>
                  <el-option label="待回答" value="1"></el-option>
                  <el-option label="已回答" value="3"></el-option>
                  <el-option label="已结束" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="提问时间：" class="ml-lg width-auto">
                <el-date-picker
                    v-model="search.time_range"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="ml-lg">
                <el-button style="background-color: #f16622;border-color:#f16622"
                           type="primary"
                           size="small"
                           @click="funSearch">查 询
                </el-button>
                <el-button style="background-color: #f16622;border-color:#f16622"
                           type="primary"
                           size="small"
                           @click="funEdit(0)">我要提问
                </el-button>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
        <el-table :data="tableDataFormat"
                  :show-header="false"
                  size="mini"
                  :row-style="{height: '40px'}"
                  style="width: 100%; font-size: 14px; color:#212121; padding-top: 30px;"
                  class="no-table_row"
                  @row-click="toDetail"
        >
          <el-table-column prop="title" label="标题" width="400px">
          </el-table-column>
          <el-table-column prop="status" label="状态" width="350px" align="right">
            <template slot-scope="scope">
              <label :style="{color: getColor(scope.row.status)}">
                {{ statusDesc(scope.row.status) }} </label> <span style="padding-left: 10px;">|</span>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="获取时间">
            <template slot-scope="scope">
              {{ scope.row.created_at }} <span>创建</span>
            </template>
          </el-table-column>
        </el-table>
        <el-row class="pagination-box" v-if="totalSum > 0" style="padding-bottom: 20px">
          <el-pagination
              class="paging"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10]"
              :current-page.sync="pageNo"
              :page-size="pageSize"
              :total="totalSum"
              layout="total, sizes, prev, pager, next">
          </el-pagination>
        </el-row>
      </div>
      <el-dialog top="70px" width="700px"
                 title="新增工单"
                 :visible.sync="showEditDialog" @close="closeEditDialog">
        <ticket-add @closeEditDialog="closeEditDialog" style="margin-left: 40px"></ticket-add>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {formatDate} from "../../assets/js/common";
import TicketPage from "../help/ticket";
import TicketAdd from "./add";

export default {
  name: "tickets",
  components: {TicketAdd, TicketPage},
  data() {
    return {
      search: {
        status: null,
        time_range: null,
      },
      pageSize: 10,
      pageNo: 1,
      totalSum: 0,
      ticketList: [],
      ticket: {},
      showEditDialog: false,
    }
  },
  computed: {
    tableDataFormat() {
      return this.ticketList.map(item => {
        if (item.title.length > 20) {
          item.title = item.title.slice(0, 20) + '...'
        }
        return item;
      })
    },
  },
  mounted() {
    this.funSearch();
  },
  methods: {
    statusDesc(status) {
      if (status === undefined) {
        return '';
      }
      let obj = this.$config.ticketStatusMap[status];
      return obj.value;
    },
    getColor(status) {
      if (status === 1) { // 待回答
        return '#F16222';
      } else if (status === 2) {
        return  '#999999'
      } else {
        return '#0bbd87';
      }
    },
    closeEditDialog() {
      this.handleCurrentChange(1);
      this.showEditDialog = false;
    },
    toDetail(row, column, event) {
      this.selectedId = row.id;
      this.$router.push(`/help/ticket/detail/${this.selectedId}`)
    },

    // 新增工单
    funEdit(action, item) {
      this.showEditDialog = true;
    },

    funSearch() {
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          this.handleCurrentChange(1);
        }
      })
    },

    handleSizeChange(size) {
      this.pageNo = 1;
      this.pageSize = size;
      this.getTicketList();
    },
    handleCurrentChange(index) {
      this.pageNo = index;
      this.getTicketList();
    },

    getTicketList() {
      if (this.isLoading) {
        return;
      }
      this.showCommonLoading();
      let start_date = null;
      let end_date = null;
      if (this.search.time_range && this.search.time_range.length > 0) {
        start_date = formatDate(this.search.time_range[0], 'yyyy-MM-dd') + ' 00:00:00';
        end_date = formatDate(this.search.time_range[1], 'yyyy-MM-dd') + ' 23:59:59';
      }
      this.$axios.post("/ajax/ticket/search", {
        ...this.search,
        created_s: start_date,
        created_e: end_date,
        page_size: this.pageSize,
        page_no: this.pageNo
      }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.ticketList = res.data.data.list || [];
          this.totalSum = parseInt(res.data.data.total);
          this.ticketList.map(item => {
            item.created_at = formatDate(item.created_at, 'yyyy-MM-dd')
            return item;
          })
        }
      }).catch(e => {
        this.hideCommonLoading();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-box {
  position: center;
  width: 50%;
  min-width: 1000px;
  margin: 50px auto;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  min-height: 500px;
}

.content-body {
  padding: 0 50px 0 40px;
}

.search-box {
  .el-input__inner {
    width: 221px;
    height: 34px;
    line-height: 34px;
  }
}

.el-input {
  width: 300px;
}

.el-textarea {
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/tickets.vue